export default __webpack_public_path__ + "static/media/notary-declaration.751c5817.svg";